import { saveAs } from 'file-saver';

const deepEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (typeof a !== typeof b) return false;
  if (typeof a !== 'object') return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every((key) => deepEqual(a[key], b[key]));
};

export const routeWithParams = (route, o) => Object.keys(o).reduce((s, p) => s.replace(new RegExp(`:${p}(?=/|$)`), o[p]), route);

// eslint-disable-next-line default-param-last
export const createReducer = (initialState, handlers) => (state = initialState, action) => {
  if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
    return handlers[action.type](state, action);
  }

  return state;
};


export const makeActionCreator = (type, ...argNames) => (...args) => {
  const action = { type };

  argNames.forEach((arg, index) => {
    action[argNames[index]] = args[index];
  });

  return action;
};

export const updateURLWithFilters = (filters, history) => {
  const { pathname } = window.location;
  const params = new URLSearchParams();

  Object.keys(filters).forEach((key) => params.append(key, filters[key]));

  const queryString = params.toString();
  const newUrl = `${pathname}${queryString && `?${queryString}`}`;

  history.replace(newUrl);
};

export const parseNull = (s) => (
  s === 'null' ? null : s
);

export const getErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (typeof error !== 'object') return JSON.stringify(error);

  const { message: regularErrorMessage, response } = error;

  if (typeof response === 'string') return response;
  if (typeof response === 'object') {
    const { data } = response;

    if (typeof data === 'string') return data;
    if (typeof data === 'object') {
      const { error_description, error, message } = data;

      if (typeof message === 'string') return message;
      if (typeof error_description === 'string') return error_description;
      if (typeof error === 'string') return error;
    }
  }

  if (typeof regularErrorMessage === 'string') return regularErrorMessage;
  if (typeof response !== 'object') return JSON.stringify(response);

  return 'Unknown error';
};

export const somePropsChanged = (o1, o2, props) => (
  props.some((prop) => !deepEqual(o1[prop], o2[prop]))
);

export const dashJoin = (arr) => arr.filter((e) => e).join(' – ');


export const removeProps = (source, props) => {
  const a = {};

  for (let i = 0, keys = Object.keys(source), l = keys.length; i < l; i += 1) {
    const key = keys[i];

    if (!props.includes(key)) {
      a[key] = source[key];
    }
  }

  return a;
};

export const isNullish = (x) => ((x ?? null) === null);

export const objectHasErrors = (o) => Object.values(o).some((e) => e);

export const op = (o, fld, dv = null) => (o && typeof o === 'object' ? o[fld] ?? dv : dv);

export const scrollToTop = () => {
  const el = document.getElementById('content');

  if (el) {
    el.scrollTo(0, 0);
  }
};

export const getMap = (arr, key = 'id') => (
  arr.reduce((a, b) => {
    if (typeof key === 'function') {
      a[key(b)] = b;
    } else {
      a[b[key]] = b;
    }

    return a;
  }, {})
);

export const downloadPDF = (pdf) => {
  if (pdf.data) {
    const filename = pdf.headers
      .get('content-disposition')
      .split('"')[1];
    const blob = new Blob([pdf.data], { type: 'application/pdf' });
    saveAs(blob, filename);
  }
};

export const downloadXLS = (pdf) => {
  if (pdf.data) {
    const filename = pdf.headers
      .get('content-disposition')
      .split('"')[1];
    const blob = new Blob([pdf.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, filename);
  }
};

export const getNewFieldInitState = (field, value) => (data) => ({
  ...data,
  [field.name]: value,
});
